import { Client, ErrorCode, EvaluationDetails, FlagValue } from '@openfeature/react-sdk'

/**
 * Evaluates a flag without knowing its type up front. It tries each type in turn and returns the first result that is
 * not a type mismatch. Meant for the debug view - in feature code, use `useRemoteFeatureFlag` with the known type.
 */
export const evaluateRemoteFeatureFlag = (client: Client, flagKey: string): EvaluationDetails<FlagValue> => {
  const booleanDetails = client.getBooleanDetails(flagKey, false)
  if (booleanDetails.errorCode !== ErrorCode.TYPE_MISMATCH) {
    return booleanDetails
  }

  const otherTypeEvaluations = [
    () => client.getStringDetails(flagKey, ''),
    () => client.getNumberDetails(flagKey, 0),
    () => client.getObjectDetails(flagKey, {}),
  ]

  for (const evaluate of otherTypeEvaluations) {
    const details = evaluate()
    if (details.errorCode !== ErrorCode.TYPE_MISMATCH) {
      return details
    }
  }

  return booleanDetails
}
